import { Component } from '@angular/core';
import { AppComponent } from './app.component';
import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { AuthService } from './login/services/auth.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {

  username = "";

  constructor(public app: HomeLayoutComponent, private authService: AuthService) {
    this.userInfo();
  }


  userInfo() {
    try {
      // this.authService.userInfo().then(data => {
      //   this.username = data['name'];
      //   debugger
      // })
    } catch{
      console.log("error getting userinfo..enable cors or check for api")
    }
  }

  logout() {
    this.authService.logout();
  }
}
